const $ = jQuery;

export class Valoration_Course {
    
    constructor(){
        this.score();
        this.save();
        this.limit_comment();
    }

    score() {
        $('#survey_form .input_stars i').on('click', function() {
            let score = $(this).attr('data-score');
            // asigna puntaje
            $('#survey_form_score').val(score);
            // pinta estrellas
            $('#survey_form .input_stars i').removeClass('checked');
            $('#survey_form .input_stars i').each(function(index, item){
                if (index < score) $(item).addClass('checked');
            })
        });
    }

    save(){
        $('#survey_form').on('submit', function(e){
            e.preventDefault();
            const formData = $(this).serialize();
            jQuery.ajax({
                type: 'POST',
                dataType: 'json',
                url: appVars.ajaxUrl,
                data: formData,
                error: function(response){
                    console.log(response);
                },
                beforeSend: function(){
                    $('#survey_form').addClass('__loading');
                },
                success: function(response){
                    // console.log(response);
                    $('#survey_form').removeClass('__loading');
                    $('#survey_form_content').hide();
                    $('#survey_success').show();
                }
            });
        })
    }

    limit_comment(){
        const max = 300;
        $('#add_comment').on('input', function(){
            const text = $(this).val();
            if (text.length > max) {
                $(this).val(text.substring(0, max));
            }
            $('#rating_comment_count').text(`${$(this).val().length}/${max}`);
        })
    }
}